<template>
  <div class="row">
  <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="card vx-card">
            <div class="card-header bg-white">
              <h4 class="card-title">
                <strong>
                  Información {{ $store.state.general_configurations.custom_quotation_name }}
                  <span class="text-primary"># {{ consecutive }}</span>
                  </strong>
                <span class="float-right">
                  <i class="fa fa-calendar text-primary"></i>
                  {{ new  Date() | moment('DD/MM/YYYY hh:mm a') }}
                </span>
              </h4>
            </div>

            <div class="card-body">

              <!-- add items -->
                <add-items-document 
                  :items="items"
                  :type="'quotation'">

                    <template slot="other-fields"></template>

                    <template slot="buttons"></template>

                </add-items-document>
              <!-- end add items -->
              
            </div>
          </div>

        </div>
      </div>
  </div>
</div>

</template>

<script>
import  itemsService from "../../services/items.service";
import AddItemsDocument from '@/components/AddItemsDocument.vue';
import { mapState } from 'vuex';

export default {
  name: 'new-quotation',
  components: {
    AddItemsDocument
  },
  data () {
    return {
      items: [],
    }
  },
  computed: {
    ...mapState(['tax_types', 'selected_items', 'consecutives']),
    consecutive() {
      return this.consecutives['qt'];
    }
  },
  methods: {
    getTaxTypes() {
      this.$store.dispatch('getTaxTypes', {});
    },
    getItems(page = 0) {
      itemsService.getItems(page).then(res => {
        this.items = res.data;
      }).catch(error => {
        if(error.response.status == 401) {
          // localStorage.clear();
          // this.$router.push('login');
        }
      })
    },
    
    setCurrency(symbol = '$') {
      this.$CurrencyFilter.setConfig({symbol: symbol})
    }
  },
  created() {
    this.getItems();
    this.getTaxTypes();
  }
}
</script>

<style scoped>
  .form-group label {
    font-weight: bold;
  }
</style>
